import { render, staticRenderFns } from "./PreferredContact.vue?vue&type=template&id=a7a9e8ae"
import script from "./PreferredContact.vue?vue&type=script&lang=js"
export * from "./PreferredContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports